<div class="forgot d-flex justify-content-center align-items-center">
    <div class="d-flex flex-column align-items-center pb-4">
        <img src="../img/main-logo.png" alt="Logo" width="220" />
        <div class="forgot__inner mt-3 mb-5 p-4">
            @if(!success){
                <div>
                    <p class="forgot__title mb-0">Forgot Password?</p>
                    <p class="forgot__desc">No worries! Enter you email address and we will send a link to set your new password.</p>
                    <div class="form-field mb-3">
                        <label class="forgot__label" for="email">Email</label>
                        <input type="text" id="email" class="form-control" [(ngModel)]="userEmail" />
                    </div>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-primary btn-sm text-uppercase px-4" [disabled]="!(userEmail)" (click)="changePassword()">Reset Password</button>
                    </div>
                </div>
            }
            @else {
                <p class="forgot__desc">We have sent an email to reset your password on your email address. Please check spam folder incase you didn't see in your inbox.</p>
            }
        </div>
    </div>
</div>